import { createFileRoute } from "@tanstack/react-router"

import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { CodeHostingPage } from "./-components/CodeHostingPage"

export const Route = createFileRoute("/features/code-hosting/")({
  head: () =>
    seoMeta({
      ...marketingPages["/features/code-hosting"],
      url: "https://entire.com/features/code-hosting",
      image: "/images/og/code-hosting.png",
      imageAlt: "Entire distributed Code Hosting",
    }),
  component: CodeHostingPage,
})
